export interface PremiumPersonalizedPlanPayload {
    id: number
    user_id: number
    first_name: string | null
    last_name: string | null
    email: string
    country: string | null
    eligible_for_30d_trial: boolean
    program_name: string
    program_status: boolean
    active: boolean
    trial: boolean
    subscription_product_id: string | null
}

export class PremiumPersonalizedPlan {
    id: number
    userId: number
    firstName: string | null
    lastName: string | null
    email: string
    country: string | null
    eligibleFor30dTrial: boolean
    programName: string
    programStatus: boolean
    active: boolean
    trial: boolean
    subscriptionProductId: string | null

    constructor(data: PremiumPersonalizedPlanPayload) {
        this.id = data.id
        this.userId = data.user_id
        this.firstName = data.first_name
        this.lastName = data.last_name
        this.email = data.email
        this.country = data.country
        this.eligibleFor30dTrial = data.eligible_for_30d_trial
        this.programName = data.program_name
        this.programStatus = data.program_status
        this.active = data.active
        this.trial = data.trial
        this.subscriptionProductId = data.subscription_product_id
    }
}
